import {Routes} from '@angular/router';
import {LayoutComponent} from './shared/layout/layout.component';
import {LoginComponent} from './pages/login/login.component';
import {ForgetPasswordComponent} from './pages/forget-password/forget-password.component';import {RegisterUserComponent} from './pages/register-user/register-user.component';
import {ConsultantDetialUserComponent} from './pages/consultant-detial-user/consultant-detial-user.component';

export const routes: Routes = [
  {
    path: 'login',
    title: 'Login',
    component: LoginComponent,
  },
  {
    path: 'forget-password',
    title: 'Forget Password',
    component: ForgetPasswordComponent,
  },
  {
    path: 'register',
    title: 'Register',
    component: RegisterUserComponent,
  },
  {
    path: 'consultant-detail/:id',
    title: 'Consultant Details',
    component:ConsultantDetialUserComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    title: 'ProTeamMate | Accelerate IT Talent Hiring',
    children: [
      {
        path: 'dashboard',
        title: 'Dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'profile',
        title: 'Profile',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
      },
      {
        path: 'talent_pool',
        title: 'Talent Pool',
        loadComponent: () => import('./pages/talent-pool/talent-pool.component').then(m => m.TalentPoolComponent),
      },
      {
        path: 'talent_pool/:id',
        title: 'Consultant Details',
        loadComponent: () => import('./pages/consultant-details/consultant-details.component').then(m => m.ConsultantDetailsComponent),
      },
      {
        path: 'solution_pool',
        title: 'Solution Pool',
        loadComponent: () => import('./pages/solution-pool/solution-pool.component').then(m => m.SolutionPoolComponent),
      },
      {
        path: 'solution_pool/:id',
        title: 'Solution Pool Detail',
        loadComponent: () => import('./pages/solution-pool-detial/solution-pool-detial.component').then(m => m.SolutionPoolDetialComponent),
      },
      {
        path: 'myList',
        title: 'My List',
        loadComponent: () => import('./pages/my-list/my-list.component').then(m => m.MyListComponent),
      },
      {
        path: 'myList/:id',
        title: 'Consultant Information',
        loadComponent: () => import('./pages/consultant-info/consultant-info.component').then(m => m.ConsultantInfoComponent),
      },
      {
        path: 'jobs',
        title: 'Jobs',
        loadComponent: () => import('./pages/jobs/jobs.component').then(m => m.JobsComponent),
      },
      {
        path: 'jobs/createJob',
        title: 'Create Job',
        loadComponent: () => import('./pages/jobs/create-job/create-job.component').then(m => m.CreateJobComponent),
      },
      {
        path: 'jobs/:id',
        title: 'Create Job',
        loadComponent: () => import('./pages/jobs/create-job/create-job.component').then(m => m.CreateJobComponent),
      },
      {
        path: 'themes',
        title: 'Themes',
        loadComponent: () => import('./pages/themes/themes.component').then(m => m.ThemesComponent),
      }
    ]
  }
];
